<template>
  <div class="disclaimer-text">
    <div class="disclaimer-header" @click="toggleDisclaimer">
      <h4>⚠️ Attention to users</h4>
      <span class="toggle-icon">{{ showDisclaimer ? '▼' : '▶' }}</span>
    </div>
    <div class="disclaimer-content" :class="{ 'expanded': showDisclaimer }">
      <div class="disclaimer-inner">
        <p>
          This website is a tool that can be used to interpret anti-infective concentrations in
          relation to ECOFFs.<br>
          The therapeutic targets and toxicity data indicated are taken from scientific literature.<br>
          Please note that they do not take into account diffusion at the site of infection.<br>
          The data are intended to guide professionals in their decision-making regarding dosage
          adjustment, but the final decision rests with the clinician, who has access to all the
          relevant clinical, microbiological and pharmacological information.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const showDisclaimer = ref(false);

const toggleDisclaimer = () => {
  showDisclaimer.value = !showDisclaimer.value;
};
</script>

<style scoped>
.disclaimer-text {
  margin: 50px 0px 20px 0px;
  padding: 10px 20px;
  width: 700px;
  background-color: #f8f9fa;
  border-left: 4px solid #007bff;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.disclaimer-text:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.disclaimer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
}

.disclaimer-header:hover {
  background-color: rgba(0, 123, 255, 0.05);
  border-radius: 4px;
  padding: 5px;
  margin: -5px;
}

.disclaimer-header h4 {
  margin: 0;
  font-size: 16px;
  color: #495057;
  font-weight: 600;
}

.toggle-icon {
  font-size: 14px;
  color: #007bff;
  transition: transform 0.3s ease;
  font-weight: bold;
}

.disclaimer-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease-out, padding 0.4s ease-out, margin 0.4s ease-out;
  padding-top: 0;
  margin-top: 0;
}

.disclaimer-content.expanded {
  max-height: 200px;
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #dee2e6;
}

.disclaimer-inner {
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.3s ease-out 0.1s, transform 0.3s ease-out 0.1s;
}

.disclaimer-content.expanded .disclaimer-inner {
  opacity: 1;
  transform: translateY(0);
}

.disclaimer-text p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #495057;
  text-align: justify;
  font-style: italic;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style> 